import React from "react";
import { Table } from "antd";
import { useParams } from "react-router-dom";

import useWindowDimensions from "../../utils/useWindowDimensions";
import useMapData from "../../utils/useMapData";

import { ReqActionBtn } from "../../StyledCmp";

import "../antTableStyles.scss";

const CostBreakupTable = ({ handleModalVisibility }) => {
  const { width } = useWindowDimensions();

  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const costBreakdownColumns = [
    {
      title: "Type",
      dataIndex: "title",
      key: "title",
      render: typeValue => {
        if (typeValue) {
          return <p>{typeValue}</p>;
        }
      },
    },
    {
      title: "Carpet Area",
      dataIndex: "carpetArea",
      key: "carpetArea",
      render: carpetAreaValue => {
        if (carpetAreaValue) {
          return <p>{carpetAreaValue}</p>;
        }
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: price => {
        if (price) {
          return (
            <div className="price_breakdown_wrapper">
              <p>{price}</p>
              <ReqActionBtn
                onClick={handleModalVisibility}
                style={{ color: resultList.themeColor }}
              >
                Price Breakup
              </ReqActionBtn>
            </div>
          );
        }
      },
    },
  ];

  const isWideScreen = width > 768;

  return (
    <>
      <Table
        columns={costBreakdownColumns}
        dataSource={resultList.sitePlanDetails}
        scroll={{ x: isWideScreen ? true : 800, y: 600 }}
        className="costBreakdown_table"
      />
    </>
  );
};

export default CostBreakupTable;
